const pickers = {
  namespaced: true,
  state: {
    // 经纬度
    latlng: {
      lat: 0,
      lng: 0,
    },
    // 地址（例：广西玉林市玉州区广场东路415号）
    address: '',
    // 所选地址名称（例：金姆指集团）
    name: '',
    // 城市名称（例：玉林）
    city: '',
  },
  mutations: {
    SET_LOCATION(state, payload) {
      state.latlng = payload.latlng;
      state.address = payload.poiaddress;
      state.name = payload.poiname === '我的位置' ? '' : payload.poiname;
      state.city = payload.cityname;
    },
    upChang(state, values) {
      if (values) {
        state.name = values;
        state.address = '';
        state.city = '';
      }
    },
  },
  actions: {
    upSelectedChange(context, val) {
      context.commit('upChang', val);
    },
    // setLocation(context,payload){
    //     context.commit('SET_LOCATION',payload)
    // }
    setLocation({ commit }, location) {
      commit('SET_LOCATION', location);
    },
  },
};
export default pickers;
